import { Injectable } from '@angular/core';
import { GenericAction } from '@common-modules/redux/models/generic-action';
import { GenericExtendedSelector } from '@common-modules/redux/models/generic-extended-selector';
import { GenericSelector } from '@common-modules/redux/models/generic-selector';
import { StateWidgetSettings } from '@common-modules/redux/models/state-widget-settings';
import { Observable } from 'rxjs';

@Injectable()
export abstract class StateService {
  abstract configure(settings: StateWidgetSettings): void;

  abstract dispatch(action: GenericAction): void;

  abstract select<T>(selector: GenericSelector | GenericExtendedSelector): Observable<T>;
}
